import {
  useMemo,
} from 'react';
import type {
  ReactElement,
  HTMLAttributes,
} from 'react';

import styled from 'styled-components';

import { GridContext } from './GridContext';

export type StyledGridProps = {
  $centered: boolean;
  $isFixedWidth: boolean;
};

export const StyledGrid = styled.div<StyledGridProps>(({
  $centered,
  $isFixedWidth,

  theme: {
    grid,
    indents,
  },
}) => {
  const MAX_WIDTH = grid.GRID_MAX_WIDTH + 2 * indents.INDENT_4 - grid.COLS_INDENT;

  return {
    boxSizing: 'border-box',
    [$isFixedWidth ? 'width' : 'maxWidth']: MAX_WIDTH,
    paddingLeft: indents.INDENT_4,
    paddingRight: indents.INDENT_4,
    marginLeft: $centered ? 'auto' : undefined,
    marginRight: $centered ? 'auto' : undefined,
  };
});

export type GridProps = HTMLAttributes<HTMLDivElement> & {
  /**
   * Добавить ли margin слева и справа
   */
  centered?: boolean;
  /**
  * Не давать контенту сужаться
  */
  isFixedWidth?: boolean;
};

export function Grid({
  centered = false,
  isFixedWidth = false,
  ...rest
}: GridProps): ReactElement {
  const contextValue = useMemo(() => ({
    isFixedWidth,
  }), [isFixedWidth]);

  return (
    <GridContext.Provider
      value={contextValue}
    >
      <StyledGrid
        $centered={centered}
        $isFixedWidth={isFixedWidth}
        {...rest}
      />
    </GridContext.Provider>
  );
}
